/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExportAsCsvRequestDto } from '../models/ExportAsCsvRequestDto';
import type { LineageEntityDto } from '../models/LineageEntityDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LineageService {

    /**
     * Export lineage as csv
     * @returns any Export lineage as csv
     * @throws ApiError
     */
    public static exportAsCsv({
        requestBody,
    }: {
        requestBody: ExportAsCsvRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/lineages/_export_as_csv',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get lineage from a given resource urn
     * @returns LineageEntityDto The lineage
     * @throws ApiError
     */
    public static getLineageByUrn({
        urn,
    }: {
        urn: string,
    }): CancelablePromise<LineageEntityDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/lineages/{urn}',
            path: {
                'urn': urn,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get lineage downstreams from a given resource urn
     * @returns LineageEntityDto The lineage downstreams entities
     * @throws ApiError
     */
    public static getLineageDownstreamsByUrn({
        urn,
    }: {
        urn: string,
    }): CancelablePromise<Array<LineageEntityDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/lineages/{urn}/downstreams',
            path: {
                'urn': urn,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get every downstream lineages from a given resource urn
     * @returns LineageEntityDto The lineages
     * @throws ApiError
     */
    public static getLineagesByUrn({
        urn,
    }: {
        urn: string,
    }): CancelablePromise<Array<LineageEntityDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/lineages/{urn}/lineages',
            path: {
                'urn': urn,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get lineage upstreams from a given resource urn
     * @returns LineageEntityDto The lineage upstreams entities
     * @throws ApiError
     */
    public static getLineageUpstreamsByUrn({
        urn,
    }: {
        urn: string,
    }): CancelablePromise<Array<LineageEntityDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/lineages/{urn}/upstreams',
            path: {
                'urn': urn,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
